import { channelClient } from 'shared/channels';
import type { FileServicesUnion } from 'shared/domain/messages/httpQueue/eventMessages';
import { httpQueueContract } from './httpQueueContract';

/** The worker's HTTP queue. */
export const httpQueueClient = {
  /** Drops the queued upload of a file and its local copy. */
  abortUpload(localId: number, type: FileServicesUnion): void {
    channelClient.notify(httpQueueContract, 'abortUpload', { localId, type });
  },
};
